import React from 'react'
import Navbars from '../Utility/Navbars'
import Services from '../Home/Services'
import create from "../Images/create.png"
import ApplyNow from '../Home/ApplyNow'
// import Slider from '../Home/Slider'
import Footer from '../Home/Footer'
import Marquee from '../Home/Marquee'
import Company from '../Home/Company'
import CardSlider from '../Home/CardSlider'
import goldVideo from "../Images/video.mp4"
import { useRef, useState } from 'react'
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from 'swiper/modules';
// Import Swiper styles
import "swiper/css";
import "./Home.css";
import sliderOne from '../Images/sliderNew/anjaliweb.jpg'
import sliderTwo from '../Images/sliderNew/ganeshaweb.jpg'
import sliderThree from '../Images/sliderNew/malvikaweb.jpg'
import sliderFour from '../Images/sliderNew/sudharani.jpg'
import OnLoadPopup from '../components/onLoadPopup'

function Home() {
  const [isVideoPlaying, setIsVideoPlaying] = useState(true);
  return (
    <>
      <Navbars />
      <OnLoadPopup/>
      {/* <section className="showcase" >
        <video className='banner-video'
          loop
          muted
          autoPlay={isVideoPlaying}
          playsInline
          webkit-playsInline
        >
          <source src={goldVideo} type="video/mp4" />
        </video>
        <div className="overlay">
        </div>
        <Company />

      </section> */}
      <section>
        <div className='banner-slider-fUll'>
          <Swiper
            modules={[Autoplay]}
            autoplay={{
              delay: 3000,       // Slide every 3 seconds
              disableOnInteraction: false, // Keeps autoplay after user interaction
            }}
            loop={true}
            spaceBetween={30}
            slidesPerView={1}
          >
            <SwiperSlide><img className='img-fluid' src={sliderOne} /></SwiperSlide>
            <SwiperSlide><img className='img-fluid' src={sliderTwo} /></SwiperSlide>
            <SwiperSlide><img className='img-fluid' src={sliderThree} /></SwiperSlide>
            <SwiperSlide><img className='img-fluid' src={sliderFour} /></SwiperSlide>
          </Swiper>
          {/* <div className="overlaySlider"></div> */}
          <div className='homePageFloatin'>
            <Company />
          </div>
        </div>
      </section>
      <Services />
      <section className='full-width-calculate'>
        <img src={create} alt='full-img' className="img-fluid img-cal" />
        <img src={create} alt='full-img' className="img-fluid img-cal-mob" />
        <div className='calculate-now-btn'> <a href='/calculator' className='text-decoration-none'>Calculate Now</a></div>
      </section>
      <ApplyNow />
      <CardSlider />
      <Footer />
      <Marquee />
    </>
  )
}

export default Home